
import React from 'react';

const PhilosophySection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">
            企業理念
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-target-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">使命（Mission）</h3>
              <p className="text-gray-700 leading-relaxed">
                地域に根ざし、安心できる住まいの提供を通じて街の未来を支える
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">価値観（Value）</h3>
              <p className="text-gray-700 leading-relaxed">
                誠実・信頼・地域貢献を大切にし、お客様との長期的な関係を築く
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-eye-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">ビジョン（Vision）</h3>
              <p className="text-gray-700 leading-relaxed">
                「地域の暮らしインフラ」として選ばれ続ける存在へ
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
